export default {
  name: 'uqlDatasource',
  title: 'UQL Datasource',
  owner: 'User: Nachi Mistry',
  solution: '',
  tags: ['datasources', 'uql'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  globals: {
    timerange: {
      since: 'now-1h',
      until: 'now',
    },
    top: 5,
  },
  spec: {
    datasources: {
      diskwrite: {
        type: 'uql',
        options: {
          since: '/${ globals.variables.since }',
          until: '/${ globals.variables.until }',
          from: 'FROM entities(aws:ec2)',
          order: 'ORDER topology.desc(Outbound)',
          limit: '/${ "LIMITS topology.count(" & globals.top & ")" }',
          fetch:
            'FETCH Instance: id, Outbound:metrics( infra:system.disk.read.operations_sec, "aws-cloudwatch").value, metrics( infra:system.disk.read.operations_sec, "aws-cloudwatch"){timestamp, value}',
          // since and until are automatically injected into the query
          queryStr: "${ $join([from, fetch, order, limit], ' ') }",
        },
      },
    },
    view: [
      [
        'div',
        { '.': 'h-[300px]' },
        [
          [
            'dashify:Highcharts',
            {
              height: 300,
              series: "/${ data.diskwrite.data.{'name': Instance, 'data': metrics.[timestamp,value] } }",
            },
          ],
        ],
      ],
    ],
  },
};
